import { ROUTER_PATHS, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchGetSolicitudTransferenciaInventario } from "@/shared/actions/erp";
import { GeneralTable, TableTabsScene, } from "@/shared/components/ui";
import { useTableSolicitudTransferenciaInventario } from "@/shared/hooks/useTableSolicitudTransferenciaInventario";
import { EstadoSolicitudTransferencia, IDataSolicitudTraslado } from "@/shared/interfaces";
import { MRT_RowData } from "material-react-table";
import { useNavigate } from "react-router-dom";

const TransferenciaInventarioEsperaPage = () => {

  const navigate = useNavigate();

  const {
    columnaBase
  } = useTableSolicitudTransferenciaInventario();

  const {
    globalFilter,
    pagination,
    onChangeFilter,
    setPagination,
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex } = pagination;

  const { isLoading, data: transferenciaProducto,
    isRefetching, } = useFetchGetSolicitudTransferenciaInventario(
      {
        page: pageIndex + 1,
        page_size: 10,
        estado_solicitud: EstadoSolicitudTransferencia.APROBADO,
        numero_referencia: globalFilter,
        ...filterObject,
        filterByState: false
      }
    );

  ///console.log('data', transferenciaProducto)

  const onEdit = (e: MRT_RowData) => {
    //navigate(ROUTER_PATHS.inventario.trasladoInventarioIngresoNav + e.id_solicitudtraslado);
    navigate(`${ROUTER_PATHS.inventario.trasladoInventarioIngresoNav}/${e.id_solicitudtraslado}`);
  }

  return (
    <TableTabsScene
      globalFilter={globalFilter}
      onChangeFilter={onChangeFilter}
      showFieldFilter={false}
    >
      <GeneralTable<IDataSolicitudTraslado>
        columns={columnaBase}
        data={transferenciaProducto?.data.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // onGlobalFilterChange={setGlobalFilter}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={transferenciaProducto?.data.count}
        // // actions
        actionsColumnSize={120}
        // crud
        onEdit={onEdit}
        canDelete={false}
        positionActionsColumn='first'
        enableColumnActions={true}
        enableEditing={true}

        ///* filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableSorting={false}
      />
    </TableTabsScene>


  );
}


export default TransferenciaInventarioEsperaPage;